import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";

declare const window: any;

export default function LocationContainer({
  data,
  setisMapRenderVIAS,
  setisMapRenderPOIS,
  setIsMapFoto360POIS,
  isMapRenderVIAS,
  isMapRenderPOIS,
  isMapFoto360POIS,
  isPortrait,
  setIsSelectedPOI,
  setIsSelectedVIA,
  isSelectedPOI,
  isSelectedVIA,
  setGaleriaSelected,
  setSubMenuSelected,
  subMenuSelected,
  setMenuSelected,
  menuSelected,
  theme,
  isSelected,
  setIsSelected,
  icono,
  colors,
  setIsSelectedAttribute,
  setCurrentSelectedAttribute,
  isSelectedAttribute,
  setSelectAvailability,
  selectAvailability,
  setFrame,
  isSideBar,
  setIsSideBar,
  setHotspotsSelected,
  version,
  isSelectedAptoView,
  setIsSelectedAptoView,
}: any) {
  
  return (
    <div className={`townplanning-container`}>
      <SideBarContainer
        data={data}
        setisMapRenderVIAS={setisMapRenderVIAS}
        setisMapRenderPOIS={setisMapRenderPOIS}
        setIsMapFoto360POIS={setIsMapFoto360POIS}
        isMapRenderVIAS={isMapRenderVIAS}
        isMapRenderPOIS={isMapRenderPOIS}
        isMapFoto360POIS={isMapFoto360POIS}
        isPortrait={isPortrait}
        setIsSelectedPOI={setIsSelectedPOI}
        setIsSelectedVIA={setIsSelectedVIA}
        isSelectedPOI={isSelectedPOI}
        isSelectedVIA={isSelectedVIA}
        setGaleriaSelected={setGaleriaSelected}
        setSubMenuSelected={setSubMenuSelected}
        subMenuSelected={subMenuSelected}
        setMenuSelected={setMenuSelected}
        theme={theme}
        isSideBar={isSideBar}
        setIsSideBar={setIsSideBar}
        menuSelected={menuSelected}
        icono={icono}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        colors={colors}
        setIsSelectedAttribute={setIsSelectedAttribute}
        setCurrentSelectedAttribute={setCurrentSelectedAttribute}
        isSelectedAttribute={isSelectedAttribute}
        setSelectAvailability={setSelectAvailability}
        selectAvailability={selectAvailability}
        setFrame={setFrame}
        setHotspotsSelected={setHotspotsSelected}
        version={version}
        isSelectedAptoView={isSelectedAptoView}
        setIsSelectedAptoView={setIsSelectedAptoView}
      />
    </div>
  );
}
